var _excluded = ["arrow", "size", "disabled", "trigger", "placement", "menu", "dropdownRender", "overlayClassName", "overlayStyle", "children", "getPopupContainer", "open", "onOpenChange", "mask", "maskClosable"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { cx } from '@emotion/css';
import React, { useMemo, useState } from 'react';
import Trigger from "../Trigger";
import DropdownMenu from "./DropdownMenu";
import { cssDropdown, prefix } from "./style";
import useThemeProps from "../../hooks/useThemeProps";
import useEvent from "../../hooks/useEvent";

var Dropdown = function Dropdown(props) {
  var arrow = props.arrow,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      disabled = props.disabled,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'hover' : _props$trigger,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bl' : _props$placement,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? {
    items: [],
    onClick: undefined
  } : _props$menu,
      dropdownRender = props.dropdownRender,
      overlayClassName = props.overlayClassName,
      overlayStyle = props.overlayStyle,
      children = props.children,
      getPopupContainer = props.getPopupContainer,
      open = props.open,
      onOpenChange = props.onOpenChange,
      mask = props.mask,
      maskClosable = props.maskClosable,
      restProps = _objectWithoutProperties(props, _excluded);

  var theme = useThemeProps();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      internalOpen = _useState2[0],
      setInternalOpen = _useState2[1];

  var mergedOpen = open !== null && open !== void 0 ? open : internalOpen;

  var handleVisibleChange = function handleVisibleChange(newVal) {
    setInternalOpen(newVal);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(newVal);
  };

  var onItemClick = useEvent(function (item) {
    if (item.type === 'default' && item.children && item.children.length > 0 || item.type === 'group' && item.groupItemClickable === false) {
      return;
    }

    setInternalOpen(false);
  });
  var dropdownMenu = useMemo(function () {
    return /*#__PURE__*/React.createElement(DropdownMenu, {
      size: size,
      items: menu.items,
      onClick: function onClick(_ref) {
        var _menu$onClick;

        var item = _ref.item,
            key = _ref.key,
            domEvent = _ref.domEvent;
        (_menu$onClick = menu.onClick) === null || _menu$onClick === void 0 ? void 0 : _menu$onClick.call(menu, {
          item: item,
          key: key,
          domEvent: domEvent
        });
        onItemClick(item);
      }
    });
  }, [size, menu, onItemClick]);
  var triggerHideAction;

  if (trigger.indexOf('contextMenu') !== -1) {
    triggerHideAction = ['click'];
  }

  return /*#__PURE__*/React.createElement(Trigger, _extends({}, restProps, {
    arrow: arrow,
    prefixCls: prefix(),
    popupVisible: disabled === true ? false : mergedOpen,
    onPopupVisibleChange: handleVisibleChange,
    action: trigger,
    hideAction: triggerHideAction,
    placement: placement,
    popup: dropdownRender ? dropdownRender(dropdownMenu) : dropdownMenu,
    popupClassName: cx(overlayClassName, cssDropdown(theme), prefix(), prefix("-".concat(size))()),
    popupStyle: overlayStyle,
    getPopupContainer: getPopupContainer,
    mask: mask,
    maskClosable: maskClosable
  }), children);
};

Dropdown.defaultProps = {
  arrow: false,
  size: 'medium',
  disabled: false,
  trigger: 'hover',
  placement: 'bl',
  menu: {
    items: []
  }
};
Dropdown.displayName = 'Dropdown';
export default /*#__PURE__*/React.memo(Dropdown);